<template>
  <div>
    <PageAllow controller="PositionMoves" action="view" />
    <Breadcrumbs :items="items" />

    <ValidationObserver ref="observer">
      <v-sheet class="transparent-background-color pa-4">
        <v-expansion-panels v-model="panels" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{ $t("CRUD.info", [$t("MovePositionOrder.ObjectName")]) }}
                <v-chip
                  v-if="!isNew"
                  small
                  label
                  class="ms-4 mt-1"
                  :color="moveOrder.type | movePositionOrderTypesColor"
                  :text-color="moveOrder.type | movePositionOrderTypesTextColor"
                  >{{ moveOrder.type | movePositionOrderTypesText }}
                </v-chip>
                <v-spacer />
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <v-btn
                    v-if="preview"
                    small
                    dark
                    outlined
                    color="secondary"
                    class="px-2 me-2 mb-1 elevation-1"
                    @click.stop="preview = false"
                  >
                    <v-icon x-small class="pe-1">fa-times</v-icon>
                    {{ $t("CRUD.backForModify") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      isNew &&
                      $permission.permissionAllow('PositionMoves', 'add')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="preview ? doSubmit() : doPreview()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{
                      $t("MovePositionOrder.actions.submitMovePositionOrder")
                    }}
                  </v-btn>
                  <v-btn
                    v-if="
                      mode == 'edit' &&
                      moveOrder.actions &&
                      moveOrder.actions.edit &&
                      $permission.permissionAllow('PositionMoves', 'edit')
                    "
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                    @click.stop="preview ? doSubmit() : doPreview()"
                  >
                    <v-icon x-small class="pe-1">fa-save</v-icon>
                    {{
                      $t("MovePositionOrder.actions.submitMovePositionOrder")
                    }}
                  </v-btn>
                  <v-btn
                    v-if="
                      mode == 'shelveOff' &&
                      moveOrder.actions &&
                      moveOrder.actions.shelve_off &&
                      $permission.permissionAllow('PositionMoves', 'shelveOff')
                    "
                    small
                    dark
                    color="action"
                    class="px-2 me-2 mb-1"
                    @click.stop="shelveOffMovePositionOrder()"
                  >
                    {{ $t("MovePositionOrder.actions.shelveOff") }}
                  </v-btn>
                  <v-btn
                    v-if="
                      mode == 'shelveOn' &&
                      moveOrder.actions &&
                      moveOrder.actions.shelve_on &&
                      $permission.permissionAllow('PositionMoves', 'shelveOn')
                    "
                    small
                    dark
                    color="action"
                    class="px-2 me-2 mb-1"
                    @click.stop="shelveOnMovePositionOrder()"
                  >
                    {{ $t("MovePositionOrder.actions.shelveOn") }}
                  </v-btn>
                </v-sheet>
                <MovePositionOrderActions
                  v-if="isView"
                  :move_position_order="moveOrder"
                  @edit="mode = 'edit'"
                  @shelveOff="mode = 'shelveOff'"
                  @shelveOn="mode = 'shelveOn'"
                  showEdit
                  showShelveOff
                  showShelveOn
                  showCancel
                  detail-mode
                />
              </v-card-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <v-col v-if="!isNew" cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{
                        $t(
                          "MovePositionOrder.DetailFields.move_position_order_code"
                        )
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ moveOrder.move_order_code }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("MovePositionOrder.DetailFields.stock_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherStock
                      v-if="isNew && !preview"
                      noLabel
                      v-model="stockSelected"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                      :stockTypes="[0]"
                      :wmsSetting="[1]"
                    />
                    <span v-else>
                      {{
                        moveOrder && moveOrder.stock ? moveOrder.stock.name : ""
                      }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 移库方式 -->
                <!-- <v-col v-if="isNew" cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("MovePositionOrder.moveWay.title")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-radio-group
                      v-if="!preview"
                      row
                      hide-details
                      v-model="moveOrder.type"
                      class="d-inline-block mt-n3"
                    >
                      <v-radio
                        v-for="way in $consts.movePositionOrder.way"
                        :label="way.text"
                        :key="way.value"
                        :value="way.value"
                      ></v-radio>
                    </v-radio-group>
                    <span v-else>
                      {{ moveOrder.type | movePositionOrderWaysText }}
                    </span>
                  </v-card>
                </v-col> -->
                <!-- 操作人(未选择仓库时的位置) -->
                <!-- <v-col
                  v-if="isNew && (!stock_id || moveOrder.type == 2)"
                  cols="12"
                  md="4"
                >
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("MovePositionOrder.DetailFields.operater_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <SearcherAccountUser
                      v-if="!preview"
                      noLabel
                      :type="[1, 2]"
                      v-model="operateUser"
                      single-line
                      dense
                      hide-details
                      class="d-inline mt-0 mb-n1"
                    />
                    <span v-else>
                      {{ operateUser ? operateUser.name : "" }}
                    </span>
                  </v-card>
                </v-col> -->
                <!-- 移库类型 -->
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("MovePositionOrder.type.title")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <v-radio-group
                      v-if="isNew && !preview"
                      row
                      hide-details
                      v-model="move_type"
                      class="d-inline-block mt-n3"
                    >
                      <v-radio
                        v-for="type in $consts.movePositionOrder.type"
                        :label="type.text"
                        :key="type.value"
                        :value="type.value"
                      ></v-radio>
                    </v-radio-group>
                    <span v-else>
                      {{
                        this.moveOrder.operation_type
                          | movePositionOrderTypesText
                      }}
                    </span>
                  </v-card>
                </v-col>
                <!-- 操作人(新建单子，选择仓库后的位置) -->
                <v-col cols="12" md="4" v-if="isNew">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("MovePositionOrder.DetailFields.operater_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <ValidationProvider
                      v-if="!preview"
                      v-slot="{ errors }"
                      :name="$t('AccountUser.title')"
                      rules="required"
                    >
                      <SearcherAccountUser
                        noLabel
                        :type="[1, 2]"
                        v-model="operateUser"
                        single-line
                        dense
                        class="d-inline mt-0 mb-n1"
                        :error-messages="errors"
                      />
                    </ValidationProvider>
                    <span v-else>
                      {{ operateUser ? operateUser.name : "" }}
                    </span>
                  </v-card>
                </v-col>
                <v-col v-if="!isNew" cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                    <span class="secondary--text">
                      {{ $t("MovePositionOrder.DetailFields.created_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    <span>
                      {{ moveOrder.created | formatTime }}
                    </span>
                  </v-card>
                </v-col>
                <v-col v-if="!isNew" cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{
                        $t(
                          "MovePositionOrder.DetailFields.move_position_order_time"
                        )
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{ moveOrder.move_time | formatTime }}
                  </v-card>
                </v-col>
                <v-col v-if="!isNew" cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("MovePositionOrder.DetailFields.operater_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      moveOrder && moveOrder.operater
                        ? moveOrder.operater.name
                        : ""
                    }}
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel v-if="!isNew">
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("MovePositionOrder.actions.activities") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="order_activities"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card class="px-4 mt-4">
          <!-- 详情 -->
          <v-data-table
            v-if="!savable || mode == 'edit' || preview"
            :headers="detailsHeaders"
            :items="moveOrderDetailItems"
            :search="filter"
            multi-sort
            disable-pagination
            hide-default-footer
            :no-data-text="$t('MovePositionOrder.DetailNoData')"
            class="py-5"
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                <v-toolbar-title class="ms-n2">
                  {{ $t("CRUD.details", [$t("MovePositionOrder.ObjectName")]) }}
                </v-toolbar-title>
              </v-toolbar>
              <v-divider />
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      moveOrderDetailItems
                        ? [
                            1,
                            moveOrderDetailItems.length,
                            moveOrderDetailItems.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-spacer />
                <v-row no-gutters class="me-n3">
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:item.move_position_out="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.position_from.position_from_description }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{
                  item.position_from.stock_position_label
                    ? item.position_from.stock_position_label.label_name
                    : item.position_from.label_name
                    ? item.position_from.label_name
                    : ""
                }}
              </span>
            </template>
            <template v-slot:item.move_position_in="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.position_to.position_to_description }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{
                  item.position_to.stock_position_label
                    ? item.position_to.stock_position_label.label_name
                    : item.position_to.label_name
                    ? item.position_to.label_name
                    : ""
                }}
              </span>
            </template>
            <template
              v-if="mode == 'edit'"
              v-slot:item.stock_position_batch_num="{ item }"
            >
              {{
                item.stock_material_position
                  ? item.stock_material_position.position_num
                  : ""
              }}{{ item.unit }}
            </template>
            <template v-slot:item.move_num="{ item }">
              <span v-if="savable && !isNew">
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="{
                    max_value: {
                      max: item.stock_material_position
                        ? item.stock_material_position.position_num
                        : $consts.maxValue(),
                    },
                  }"
                >
                  <NumberInput
                    v-model="item.move_num"
                    :error-messages="errors"
                    dense
                  >
                    <template v-slot:append>
                      {{ item.default_unit }}
                    </template>
                  </NumberInput>
                </ValidationProvider>
              </span>
              <span v-else>
                {{ item.move_num | formatTwoDot }}
              </span>
            </template>
          </v-data-table>
          <!-- 手动移库新增 -->
          <v-data-table
            v-if="isNew && moveOrder.type == 1 && !preview"
            :headers="moveOrder.type == 2 || move_type ? savableHeaders : []"
            :items="
              moveOrder.type == 2
                ? autoMoveMaterialDetail
                : move_type == 1
                ? materialBatchDetail
                : stockPositionBatchDetail
            "
            :search="savableFilter"
            multi-sort
            disable-pagination
            hide-default-footer
            :no-data-text="$t('MovePositionOrder.DetailNoData')"
            class="py-5"
            :group-by="
              move_type == 1
                ? 'position_description'
                : move_type == 2 || moveOrder.type == 2
                ? 'material_description'
                : ''
            "
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                <v-toolbar-title class="ms-n2">
                  {{ $t("CRUD.details", [$t("MovePositionOrder.ObjectName")]) }}
                </v-toolbar-title>
              </v-toolbar>
              <v-divider />
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stockPositionBatchDetail
                        ? [
                            1,
                            stockPositionBatchDetail.length,
                            stockPositionBatchDetail.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-spacer />
                <v-row no-gutters class="me-n3">
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:body.prepend>
              <tr
                v-if="stock_id && moveOrder.type == 1 && isNew"
                class="d-table-row"
              >
                <td :colspan="detailsHeaders.length">
                  <v-row no-gutters align="center" class="text-no-wrap d-flex">
                    <keep-alive v-if="move_type == 2">
                      <SearcherStockMaterials
                        v-model="moveMaterialSeleted"
                        :stock-id="stock_id"
                        :label="
                          $t('MovePositionOrder.DetailFields.select_material')
                        "
                      />
                    </keep-alive>
                    <keep-alive v-if="move_type == 1">
                      <SearcherStockPositions
                        class="d-inline-block"
                        v-model="moveStockPositionSelected"
                        :stock-id="stock_id"
                        :status="1"
                        :label="
                          $t('MovePositionOrder.DetailFields.select_position')
                        "
                      />
                    </keep-alive>
                  </v-row>
                </td>
              </tr>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:group.header="{ isOpen, toggle, group, items }">
              <td
                :colspan="
                  move_type || moveOrder.type == 2
                    ? savableHeaders.length - 1
                    : savableHeaders.length
                "
              >
                {{ group }}
              </td>
              <td align="center" @click="toggle">
                <v-icon class="pe-1" size="30px" v-if="!isOpen"
                  >fa-angle-down</v-icon
                >
                <v-icon class="pe-1" size="30px" v-else>fa-angle-up</v-icon>
                <v-btn
                  v-if="move_type == 1"
                  small
                  text
                  class="danger--text pa-0"
                  @click.stop="removeItem(items)"
                >
                  <v-icon>fa-times</v-icon>
                </v-btn>
              </td>
            </template>
            <!-- 安库位移库 -->
            <template v-slot:item.material_description="{ item }">
              <a
                class="text-no-wrap"
                @click="
                  currentDetail = item;
                  positionBatchDialog = true;
                "
              >
                {{ item.material_description }}
              </a>
            </template>
            <!-- 按商品移库 -->
            <template v-slot:item.position_name="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.position_description }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.label_name }}
              </span>
            </template>
            <template v-slot:item.stock_batch_code="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{ item.stock_batch_code }}
                <v-chip
                  v-if="item.expired_flg"
                  x-small
                  label
                  :color="item.expired_flg | expiredFlgsColor"
                  :text-color="item.expired_flg | expiredFlgsTextColor"
                >
                  {{ item.expired_flg | expiredFlgsText }}
                </v-chip>

                <v-chip
                  v-if="item.prohibit_flg"
                  x-small
                  label
                  :color="item.prohibit_flg | prohibitFlgsColor"
                  :text-color="item.prohibit_flg | prohibitFlgsTextColor"
                >
                  {{ item.prohibit_flg | prohibitFlgsText }}
                </v-chip>
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ $t("MovePositionOrder.DetailFields.production_date")
                }}{{ $t("Global.colon") }}
                {{ item.production_date | formatDate }}
              </span>
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ $t("MovePositionOrder.DetailFields.expired_date")
                }}{{ $t("Global.colon") }}
                {{ item.expired_date | formatDate }}
              </span>
            </template>
            <template v-slot:item.move_position_in="{ item }">
              <!-- 本页面获取库位 -->
              <ValidationProvider v-slot="{ errors }" rules="trequired">
                <v-autocomplete
                  v-model="item.moveTo"
                  :items="disabledPosition(item)"
                  :loading="stockPositionLoading"
                  :search-input.sync="item.stockPositionSearch"
                  item-value="id"
                  item-text="position_description"
                  item-disabled="disabled"
                  :label="$t('MovePositionOrder.DetailFields.move_position_in')"
                  return-object
                  clearable
                  :error-messages="errors"
                >
                </v-autocomplete>
              </ValidationProvider>
            </template>
            <template v-slot:item.move_num_count="{ item }">
              <v-menu top offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    text
                    class="px-0 py-0 caption black--text"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="getStockBatchList(item)"
                  >
                    {{ item.move_num_count }}{{ item.unit }}
                  </v-btn>
                </template>

                <v-list min-width="600px">
                  <v-list-item v-for="(detail, i) in stockDetails" :key="i">
                    <v-list-item-title>
                      <v-row class="subtitle-2">
                        <v-col cols="12" md="2" class="text-right">
                          {{
                            $t(
                              "MovePositionOrder.DetailFields.stock_batch_code"
                            ) + $t("Global.colon")
                          }}
                        </v-col>
                        <v-col cols="12" md="5" class="text-left">
                          {{ detail.stock_batch_code }}
                          <v-chip
                            v-if="detail.expired_flg"
                            x-small
                            label
                            :color="detail.expired_flg | expiredFlgsColor"
                            :text-color="
                              detail.expired_flg | expiredFlgsTextColor
                            "
                          >
                            {{ detail.expired_flg | expiredFlgsText }}
                          </v-chip>
                          <v-chip
                            v-if="detail.prohibit_flg"
                            small
                            label
                            :color="detail.prohibit_flg | prohibitFlgsColor"
                            :text-color="
                              detail.prohibit_flg | prohibitFlgsTextColor
                            "
                          >
                            {{ detail.prohibit_flg | prohibitFlgsText }}
                          </v-chip>
                        </v-col>
                        <v-col cols="12" md="2" class="text-right">
                          {{
                            $t(
                              "MovePositionOrder.DetailFields.stock_batch_num"
                            ) + $t("Global.colon")
                          }}
                        </v-col>
                        <v-col cols="12" md="3" class="text-left">
                          {{ detail.position_num + detail.unit }}
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:item.move_num="{ item }">
              <!-- 移库数量 -->
              <div v-if="moveOrder.type == 1">
                <span v-if="move_type == 2">
                  <span v-if="item.stock_material.standard_detail.rate == 1">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :rules="{
                        max_value: { max: item.position_num },
                      }"
                    >
                      <NumberInput
                        v-model="item.move_num_default"
                        :error-messages="errors"
                        dense
                      >
                        <template v-slot:append>
                          {{ item.unit }}
                        </template>
                      </NumberInput>
                    </ValidationProvider>
                  </span>
                  <span v-else>
                    <div class="d-inline-block">
                      <NumberInput v-model="item.move_num_rate" dense>
                        <template v-slot:append>
                          {{ item.stock_material.standard_detail.unit }}
                        </template>
                      </NumberInput>
                    </div>
                    <div class="d-inline-block">
                      <NumberInput v-model="item.move_num_default" dense>
                        <template v-slot:append>
                          {{ item.unit }}
                        </template>
                      </NumberInput>
                    </div>
                  </span>
                </span>
                <span v-else> {{ item.move_num_count }}{{ item.unit }} </span>
              </div>
            </template>
            <template v-if="move_type == 2" v-slot:item.actions="{ item }">
              <v-btn
                small
                text
                class="danger--text pa-0"
                @click.stop="removeItem(item)"
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <!-- 自动移库新增 -->
          <v-data-table
            v-if="isNew && moveOrder.type == 2 && !preview"
            :headers="savableHeaders"
            :items="editAutoMoveDetail"
            :search="savableFilter"
            multi-sort
            disable-pagination
            hide-default-footer
            :no-data-text="$t('MovePositionOrder.DetailNoData')"
            class="py-5"
            group-by="material_description"
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                <v-toolbar-title class="ms-n2">
                  {{ $t("CRUD.details", [$t("MovePositionOrder.ObjectName")]) }}
                </v-toolbar-title>
                <v-spacer />
                <v-btn
                  v-if="stock_id"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click="addAutoMovePositionDetails()"
                >
                  {{ $t("MovePositionOrder.actions.autoMovePositionOrderBtn") }}
                </v-btn>
              </v-toolbar>
              <v-divider />
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      editAutoMoveDetail
                        ? [
                            1,
                            editAutoMoveDetail.length,
                            editAutoMoveDetail.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-spacer />
                <v-row no-gutters class="me-n3">
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:group.header="{ isOpen, toggle, group, items }">
              <td :colspan="savableHeaders.length - 3">
                {{ group }}
              </td>
              <td>
                {{
                  $t("MovePositionOrder.DetailFields.material_category") +
                  $t("Global.colon")
                }}{{ items[0].category_name }}
              </td>
              <td>
                {{
                  $t("MovePositionOrder.DetailFields.auto_move_num") +
                  $t("Global.colon")
                }}{{ items[0].stock_num }}
              </td>
              <td align="center" @click="toggle">
                <v-icon class="pe-1" size="30px" v-if="!isOpen"
                  >fa-angle-down</v-icon
                >
                <v-icon class="pe-1" size="30px" v-else>fa-angle-up</v-icon>
              </td>
            </template>
            <template v-slot:group.summary="{ items }">
              <td :colspan="savableHeaders.length">
                <SearcherMovePosition
                  v-model="items[0].addMovePositionTo"
                  :stock="stockSelected"
                  :stockPositions="
                    autoMoveMaterialDetail[items[0].material_id].stock_positions
                  "
                />
              </td>
            </template>
            <template v-slot:item.position_name="{ item }">
              <span class="text-no-wrap caption font-weight-bold">
                {{
                  item.move_position_to
                    ? item.move_position_to.position_description
                    : ""
                }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{
                  item.move_position_to.stock_position_label
                    ? item.move_position_to.stock_position_label.label_name
                    : ""
                }}
              </span>
            </template>
            <template v-slot:item.stock_batch_code="{ item }">
              {{ item.stock_detail ? item.stock_detail.stock_batch_code : "" }}
            </template>
            <template v-slot:item.stock_position_batch_num="{ item }">
              <span v-if="item.new">
                {{
                  item.stock_rate > 1
                    ? item.stock_position_batch_num_rate
                    : item.stock_position_batch_num_default
                }}
              </span>
            </template>
            <template v-slot:item.move_position_in="{ item }">
              <!-- 本页面获取库位 -->
              <ValidationProvider
                v-if="item.new"
                v-slot="{ errors }"
                rules="trequired"
              >
                <v-autocomplete
                  v-model="item.move_position_in"
                  :items="disabledPosition(item)"
                  :loading="stockPositionLoading"
                  :search-input.sync="item.stockPositionSearch"
                  item-value="id"
                  item-text="position_description"
                  item-disabled="disabled"
                  :label="$t('MovePositionOrder.DetailFields.move_position_in')"
                  return-object
                  clearable
                  :error-messages="errors"
                >
                </v-autocomplete>
              </ValidationProvider>
            </template>
            <template v-slot:item.move_num="{ item }">
              <span v-if="item.new && item.stock_rate > 1">
                <div class="d-inline-block">
                  <NumberInput v-model="item.move_num_rate" dense>
                    <template v-slot:append>
                      {{ item.stock_unit }}
                    </template>
                  </NumberInput>
                </div>
                <div class="d-inline-block">
                  <NumberInput v-model="item.move_num_default" dense>
                    <template v-slot:append>
                      {{ item.default_unit }}
                    </template>
                  </NumberInput>
                </div>
              </span>
              <span v-else-if="item.new">
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="{
                    max_value: { max: item.position_num },
                  }"
                >
                  <NumberInput
                    v-model="item.move_num_default"
                    :error-messages="errors"
                    dense
                  >
                    <template v-slot:append>
                      {{ item.default_unit }}
                    </template>
                  </NumberInput>
                </ValidationProvider>
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                v-if="item.new"
                small
                text
                class="danger--text pa-0"
                @click.stop="removeItem(item)"
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-sheet>
    </ValidationObserver>

    <v-dialog v-model="errorMoveDialog" width="850px">
      <v-card>
        <v-card-title>
          <span class="headline" center>
            {{ $t("$vuetify.warning") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="errorMoveDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Wave.PickingFields.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <h3>
              {{
                $t("MovePositionOrder.errorMoveNumCountTitle") +
                $t("Global.colon")
              }}
            </h3>
            <v-list disabled>
              <v-list-item-group v-model="errorMoveList" color="primary">
                <v-list-item v-for="(item, i) in errorMoveList" :key="i">
                  <v-list-item-content>
                    <v-list-item-title class="subtitle-2 ml-4">
                      {{
                        $t("MovePositionOrder.errorMoveListItem", [
                          item.position_code
                            ? item.position_code
                            : item.move_position_to
                            ? item.move_position_to.position_code
                            : "",
                          item.position_name
                            ? item.position_name
                            : item.move_position_to
                            ? item.move_position_to.position_name
                            : "",
                          item.material_description,
                          item.stock_batch_code
                            ? item.stock_batch_code
                            : item.stock_detail
                            ? item.stock_detail.stock_batch_code
                            : "",
                        ])
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="errorMoveDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SelectStockBatchDialog
      v-model="stockBatchDialog"
      :stockBatch="stockPositionBatchs"
      @stockBatchSeleted="stockBatchSelectedDetail = $event"
    />
    <ShowMaterialPositionBatchDialog
      v-model="positionBatchDialog"
      :materialPositiobDetail="currentDetail"
    />
  </div>
</template>
<style>
.v-data-table .v-row-group__summary {
  background: transparent !important;
}
</style>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import MovePositionOrders from "@/api/move_position_orders";
import StockPosition from "@/api/stock_position";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherAccountUser from "@/components/plugins/SearcherAccountUser";
import SearcherStockMaterials from "@/components/plugins/SearcherStockMaterials";
import SearcherMovePosition from "./plugins/SearcherMovePosition";
import SearcherStockPositions from "@/components/plugins/SearcherStockPositions";
import NumberInput from "@/components/plugins/NumberInput";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import SelectStockBatchDialog from "./plugins/SelectStockBatchDialog";
import ShowMaterialPositionBatchDialog from "./plugins/ShowMaterialPositionBatchDialog";
import MovePositionOrderActions from "./plugins/Actions";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherStock,
    SearcherAccountUser,
    SearcherStockMaterials,
    SearcherStockPositions,
    SearcherMovePosition,
    NumberInput,
    ValidationObserver,
    ValidationProvider,
    SelectStockBatchDialog,
    ShowMaterialPositionBatchDialog,
    MovePositionOrderActions,
  },
  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return !this.preview && (this.mode == "new" || this.mode == "edit");
    },
    isNew() {
      return this.mode == "new";
    },
    isShelveOff() {
      return this.mode == "shelve-off";
    },

    stock_id() {
      return this.stockSelected ? this.stockSelected.id : 0;
    },

    stockPositionItems() {
      return this.stockPositions.map((position) => {
        var position_description = i18n.t(
          "MovePositionOrder.DetailFields.position",
          [position.position_code, position.position_name]
        );
        if (this.stockSelected && this.stockSelected.position_name_display) {
          if (this.stockSelected.position_name_display.indexOf(2) > -1) {
            position_description = position.position_name;
          }
          if (
            this.stockSelected.position_name_display.indexOf(4) > -1 &&
            position.roadway_code
          ) {
            position_description =
              position.roadway_code + " - " + position_description;
          }
          if (
            this.stockSelected.position_name_display.indexOf(3) > -1 &&
            position.area_name
          ) {
            position_description =
              position.area_name + " - " + position_description;
          }
        }
        return Object.assign({}, position, { position_description });
      });
    },

    moveOrderDetailItems() {
      return this.moveOrderDetails.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );

        //格式化库位名称
        var position_from_description = i18n.t(
          "MovePositionOrder.DetailFields.position",
          [
            detail.position_from.position_code,
            detail.position_from.position_name,
          ]
        );
        if (
          this.moveOrder.stock &&
          this.moveOrder.stock.position_name_display
        ) {
          if (this.moveOrder.stock.position_name_display.indexOf(2) > -1) {
            position_from_description = detail.position_from.position_name;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(4) > -1 &&
            detail.position_from.roadway_code
          ) {
            position_from_description =
              detail.position_from.roadway_code +
              " - " +
              position_from_description;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(3) > -1 &&
            detail.position_from.area_name
          ) {
            position_from_description =
              detail.position_from.area_name +
              " - " +
              position_from_description;
          }
        }
        detail.position_from.position_from_description =
          position_from_description;

        //格式化库位名称
        var position_to_description = i18n.t(
          "MovePositionOrder.DetailFields.position",
          [detail.position_to.position_code, detail.position_to.position_name]
        );
        if (
          this.moveOrder.stock &&
          this.moveOrder.stock.position_name_display
        ) {
          if (this.moveOrder.stock.position_name_display.indexOf(2) > -1) {
            position_to_description = detail.position_to.position_name;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(4) > -1 &&
            detail.position_to.roadway_code
          ) {
            position_to_description =
              detail.position_to.roadway_code + " - " + position_to_description;
          }
          if (
            this.moveOrder.stock.position_name_display.indexOf(3) > -1 &&
            detail.position_to.area_name
          ) {
            position_to_description =
              detail.position_to.area_name + " - " + position_to_description;
          }
        }
        detail.position_to.position_to_description = position_to_description;

        return detail;
      });
    },

    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.movePositionOrder"),
          disabled: false,
          href: "/move-position-order",
        },
        {
          text: i18n.t("Nav.movePositionOrderDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.moveOrder && this.moveOrder.move_order_code
              ? this.moveOrder.move_order_code
              : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },

    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("MovePositionOrder.DetailFields.material_category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.material"),
          align: "center",
          value: "Description",
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.move_position_out"),
          align: "center",
          value: "move_position_out",
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.stock_batch_code"),
          align: "center",
          value: "stock_detail.stock_batch_code",
        },
      ];
      if (this.mode == "edit") {
        headers.push({
          text: i18n.t(
            "MovePositionOrder.DetailFields.stock_position_batch_num"
          ),
          align: "center",
          value: "stock_position_batch_num",
        });
      }
      headers.push(
        {
          text: i18n.t("MovePositionOrder.DetailFields.move_position_in"),
          align: "center",
          value: "move_position_in",
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.move_num"),
          align: "end",
          value: "move_num",
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.unit"),
          align: "end",
          value: "unit",
        }
      );

      return headers;
    },

    savableHeaders() {
      var headers = [];
      if (this.move_type == 1) {
        headers.push(
          {
            text: i18n.t("MovePositionOrder.DetailFields.material"),
            align: "start",
            value: "material_description",
            sortable: false,
            groupable: false,
          },
          {
            text: i18n.t("MovePositionOrder.DetailFields.stock_position_num"),
            align: "start",
            value: "move_num_count",
            sortable: false,
            groupable: false,
          }
        );
      }

      if (this.move_type == 2) {
        headers.push(
          {
            text: i18n.t("MovePositionOrder.DetailFields.move_position_out"),
            align: "center",
            value: "position_name",
            sortable: false,
            groupable: false,
          },
          {
            text: i18n.t("MovePositionOrder.DetailFields.stock_batch_code"),
            align: "start",
            value: "stock_batch_code",
            sortable: false,
            groupable: false,
          },
          {
            text: i18n.t(
              "MovePositionOrder.DetailFields.stock_position_batch_num"
            ),
            align: "center",
            value: "stock_num",
            sortable: false,
            groupable: false,
          }
        );
      }

      if (this.moveOrder.type == 2) {
        headers.push(
          {
            text: i18n.t("MovePositionOrder.DetailFields.move_position_out"),
            align: "center",
            value: "position_name",
            sortable: false,
            groupable: false,
          },
          {
            text: i18n.t("MovePositionOrder.DetailFields.stock_batch_code"),
            align: "center",
            value: "stock_batch_code",
            sortable: false,
            groupable: false,
          },
          {
            text: i18n.t(
              "MovePositionOrder.DetailFields.stock_position_batch_num"
            ),
            align: "center",
            value: "stock_position_batch_num",
            sortable: false,
            groupable: false,
          }
        );
      }

      headers.push(
        {
          text: i18n.t("MovePositionOrder.DetailFields.move_position_in"),
          align: "center",
          value: "move_position_in",
          sortable: false,
          groupable: false,
        },
        {
          text: i18n.t("MovePositionOrder.DetailFields.move_num"),
          align: "center",
          value: "move_num",
          sortable: false,
          groupable: false,
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          value: "actions",
          sortable: false,
          groupable: false,
        }
      );
      return headers;
    },

    activitiesHeaders: () => [
      {
        text: i18n.t("MovePositionOrder.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("MovePositionOrder.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("MovePositionOrder.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountUser"]),
  },

  data: () => ({
    panels: [0],
    tab: null,
    filter: "",
    savableFilter: "",
    mode: "",
    preview: false,
    moveOrder: {},
    moveOrderDetails: [],
    order_activities: [],
    stockSelected: null,
    move_type: 2, //移库类型：1.库位2.商品
    operateUser: null,
    moveMaterialSeleted: [],
    moveMaterial: [],
    moveStockPositionSelected: [],
    moveStockPosition: [],
    stockPositionBatchDetail: [],
    removeArr: [],
    materialBatchDetail: [],
    stockPositions: [],
    stockPositionLoading: false,
    stockPositionSearch: "",
    moveTo: null,
    errorMoveDialog: false,
    errorMoveList: [],
    stockDetails: [],
    moveOrderBeforePreview: {},
    moveOrderDetailsPreviewed: [],
    autoMoveMaterialDetail: null,
    editAutoMoveDetail: [],
    stockBatchDialog: false,
    stockPositionBatchs: [],
    stockBatchSelectedDetail: [],
    positionBatchDialog: false,
    currentDetail: null,
  }),

  mounted() {
    if (this.$route.path.startsWith("/move-position-order/new")) {
      this.mode = "new";
    } else {
      this.mode = this.$route.params.mode;
      if (this.mode)
        this.$router.replace("/move-position-order/" + this.$route.params.id);
    }
  },

  methods: {
    //获取移库单明细
    getMoveOrderDetailFromAPI() {
      MovePositionOrders.fetchOne(this.$route.params.id, {
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.moveOrder = response.data.move;
            this.moveOrderDetails = response.data.move.move_details;
            this.order_activities = response.data.order_activities;
          }
        }.bind(this)
      );
    },
    //获取库位select列表
    getMaterialPositionDetails() {
      StockPosition.fetchAllForSelect({
        stock_id: this.stock_id,
        status: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockPositions = response.data.stock_positions;
          }
        }.bind(this)
      );
    },
    //获取库位批次详情
    getStockPositionBatchDetails(data) {
      MovePositionOrders.stockMaterialPosition(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockPositionBatchDetail =
              response.data.stock_material_positions;

            //过滤已经筛选掉的库存批次
            if (this.move_type == 2 && this.removeArr.length) {
              this.removeArr.forEach((arr) => {
                var isFind = this.stockPositionBatchDetail.findIndex(
                  (detail) => arr.id == detail.id
                );
                if (isFind > 0) {
                  this.stockPositionBatchDetail.splice(isFind, 1);
                }
              });
            }

            //单个商品
            this.stockPositionBatchDetail.forEach((detail) => {
              //商品名称跟随设置
              detail.material_description = i18n.t(
                this.settings
                  ? this.settings.material_name_display_type == 4
                    ? "Material.nameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 3
                    ? "Material.materialNameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 2
                    ? "Material.materialNameWithCode"
                    : "Material.materialName"
                  : "Material.materialName",
                [
                  detail.material.material_code,
                  detail.material.material_name,
                  detail.material.standard.name,
                ]
              );
              //库位名称
              var position_description = i18n.t(
                "MovePositionOrder.DetailFields.position",
                [detail.position_code, detail.position_name]
              );
              if (
                this.stockSelected &&
                this.stockSelected.position_name_display
              ) {
                if (this.stockSelected.position_name_display.indexOf(2) > -1) {
                  position_description = detail.position_name;
                }
                if (
                  this.stockSelected.position_name_display.indexOf(4) > -1 &&
                  detail.roadway_code
                ) {
                  position_description =
                    detail.roadway_code + " - " + position_description;
                }
                if (
                  this.stockSelected.position_name_display.indexOf(3) > -1 &&
                  detail.area_name
                ) {
                  position_description =
                    detail.area_name + " - " + position_description;
                }
              }
              detail.position_description = position_description;

              //判断批次是否过期
              if (
                detail.expired_date &&
                new Date(detail.expired_date).getTime() < new Date().getTime()
              ) {
                detail.expired_flg = 1;
              } else {
                detail.expired_flg = 0;
              }

              //移入库位详情
              detail.moveTo = null;
              //position_num换算move_num_default(基准单位),move_num_rate(大单位)
              if (detail.stock_material.standard_detail.rate > 1) {
                detail.move_num_rate = parseInt(
                  detail.position_num /
                    detail.stock_material.standard_detail.rate
                );
                detail.move_num_default =
                  detail.position_num %
                  detail.stock_material.standard_detail.rate;
              } else {
                detail.move_num_rate = 0;
                detail.move_num_default = detail.position_num;
              }
            });

            //手动移库按库位移动时，整合批次详情
            if (this.move_type == 1) {
              this.stockPositionBatchDetail.forEach((detail) => {
                var isFind = this.materialBatchDetail.find(
                  (item) =>
                    item.material_id == detail.material_id &&
                    item.stock_position_id == detail.stock_position_id
                );

                if (isFind == undefined || isFind == "undefined") {
                  this.materialBatchDetail.push({
                    material_id: detail.material_id,
                    material_description: detail.material_description,
                    move_num_count:
                      detail.move_num_default + detail.move_num_rate,
                    unit: detail.unit,
                    stock_position_id: detail.stock_position_id,
                    position_description: detail.position_description,
                    stock_details: [detail],
                  });
                }
              });
            }
          }
        }.bind(this)
      );
    },
    //库位select禁选项
    disabledPosition(batch_detail) {
      //手动移库
      if (this.moveOrder.type == 1) {
        this.stockPositionItems.forEach((position) => {
          if (position.id == batch_detail.stock_position_id) {
            position.disabled = true;
          } else {
            position.disabled = false;
          }
        });
      } else {
        //自动移库
        var editDetail = [];
        this.editAutoMoveDetail.forEach((edit_move_detail) => {
          if (edit_move_detail.new) {
            editDetail.push(edit_move_detail);
          }
        });
        this.stockPositionItems.forEach((position) => {
          position.disabled = false;
          if (position.id == batch_detail.stock_position_id) {
            position.disabled = true;
          }
          var isDisabled = editDetail.findIndex(
            (detail) =>
              detail.move_position_in &&
              detail.move_position_in.id == position.id &&
              detail.stock_detail_id == batch_detail.stock_detail_id
          );
          if (isDisabled > -1) {
            position.disabled = true;
          }
        });
      }

      return this.stockPositionItems;
    },
    //获取商品的所有库位批次详情
    getStockBatchList(data) {
      MovePositionOrders.stockMaterialPosition({
        stock_ids: this.stock_id,
        material_ids: data.material_id,
        stock_position_ids: data.stock_position_id,
      }).then(
        function (response) {
          if (response.data.status.isOK) {
            this.stockDetails = response.data.stock_material_positions;
            this.stockDetails.forEach((detail) => {
              //判断批次是否过期
              if (
                new Date(detail.expired_date).getTime() < new Date().getTime()
              ) {
                detail.expired_flg = true;
              } else {
                detail.expired_flg = false;
              }
            });
          }
        }.bind(this)
      );
    },
    //获取自动移库商品列表
    getAutoMoveMaterialList() {
      MovePositionOrders.autoMoveMaterialList({ stock_id: this.stock_id }).then(
        function (response) {
          if (response.data.status.isOK()) {
            var materialList = response.data.auto_move_material_list;

            for (var key in materialList) {
              //商品名称跟随设置
              materialList[key].material_description = i18n.t(
                this.settings
                  ? this.settings.material_name_display_type == 3
                    ? "Material.materialNameWithCodeAndStandard"
                    : this.settings.material_name_display_type == 2
                    ? "Material.materialNameWithCode"
                    : "Material.materialName"
                  : "Material.materialName",
                [
                  materialList[key].material_code,
                  materialList[key].material_name,
                  materialList[key].standard_name,
                ]
              );
              //库位名称
              materialList[key].stock_positions.forEach((position) => {
                var position_description = i18n.t(
                  "MovePositionOrder.DetailFields.position",
                  [position.position_code, position.position_name]
                );
                if (
                  this.stockSelected &&
                  this.stockSelected.position_name_display
                ) {
                  if (
                    this.stockSelected.position_name_display.indexOf(2) > -1
                  ) {
                    position_description = position.position_name;
                  }
                  if (
                    this.stockSelected.position_name_display.indexOf(4) > -1 &&
                    position.roadway_code
                  ) {
                    position_description =
                      position.roadway_code + " - " + position_description;
                  }
                  if (
                    this.stockSelected.position_name_display.indexOf(3) > -1 &&
                    position.area_name
                  ) {
                    position_description =
                      position.area_name + " - " + position_description;
                  }
                }
                position.position_description = position_description;
              });

              //自动移库基本商品信息
              var addData = JSON.parse(JSON.stringify(materialList[key]));
              this.$delete(addData, "stock_material_positions");
              this.$delete(addData, "stock_positions");
              addData.move_position_to = {};
              addData.move_position_in = {};
              this.editAutoMoveDetail.push(addData);
            }
            this.autoMoveMaterialDetail = materialList;
          }
        }.bind(this)
      );
    },
    //自动移库
    addAutoMovePositionDetails() {
      this.editAutoMoveDetail.forEach((editDetail) => {
        //统计当前商品已填写的移库量
        var move_num_count = 0;
        this.editAutoMoveDetail.find((detail) => {
          if (detail.material_id == editDetail.material_id) {
            if (detail.stock_rate > 1 && detail.move_num_rate) {
              move_num_count += detail.move_num_rate * detail.stock_rate;
            }
            if (detail.move_num_default) {
              move_num_count += detail.move_num_default;
            }
          }
        });

        //获取商品的库位批次详情
        var stockMaterialPositions =
          this.autoMoveMaterialDetail[editDetail.material_id]
            .stock_material_positions;

        //推荐移库量
        var confirmNumTotal = Number(
          this.autoMoveMaterialDetail[editDetail.material_id].confirm_num_total
        );

        //移出库位
        var stockPositions =
          this.autoMoveMaterialDetail[editDetail.material_id].stock_positions;

        //自动顺位新增
        for (var stockMaterialPositionKey in stockMaterialPositions) {
          var stockPositionBatchs =
            stockMaterialPositions[stockMaterialPositionKey];
          for (var stockPositionBatchKey in stockPositionBatchs) {
            var stockPositionBatch = stockPositionBatchs[stockPositionBatchKey];
            var copyBatchDetail = JSON.parse(
              JSON.stringify(stockPositionBatch)
            ); //深拷贝当前批次详情
            var newDetail = JSON.parse(JSON.stringify(editDetail)); //深拷贝当前商品库位批次详情
            newDetail.move_num_rate = 0; //初始化移库量
            newDetail.move_num_default = 0; //初始化移库量
            //当前库位批次已手动添加过
            var batchAddedArr = this.editAutoMoveDetail.filter(
              (moveDetail) =>
                moveDetail.stock_detail_id == stockPositionBatch.stock_detail.id
            );

            //判断当前自动添加的批次的移动量是否达到推荐移库量
            if (move_num_count < confirmNumTotal) {
              newDetail.stock_material_position_id = copyBatchDetail.id;
              // newDetail.new = true;
              //判断当前批次数量是否满足推荐移库量;
              if (batchAddedArr.length) {
                var movedNumCount = 0; //已填写的移库量
                batchAddedArr.forEach((added) => {
                  if (added.move_num_rate) {
                    movedNumCount += added.move_num_rate * added.stock_rate;
                  }
                  if (added.move_num_default) {
                    movedNumCount += added.move_num_default;
                  }
                });

                if (movedNumCount < stockPositionBatch.position_num) {
                  if (
                    stockPositionBatch.position_num <
                    confirmNumTotal - move_num_count
                  ) {
                    newDetail.move_num_default =
                      stockPositionBatch.position_num - movedNumCount;
                    move_num_count += newDetail.move_num_default;
                  } else {
                    newDetail.move_num_default =
                      confirmNumTotal - move_num_count;
                    move_num_count += newDetail.move_num_default;
                  }
                } else {
                  return;
                }
              } else {
                if (
                  stockPositionBatch.position_num >
                  confirmNumTotal - move_num_count
                ) {
                  newDetail.move_num_default = confirmNumTotal - move_num_count;
                  move_num_count += newDetail.move_num_default;
                } else if (
                  stockPositionBatch.position_num <
                    confirmNumTotal - move_num_count ||
                  stockPositionBatch.position_num ==
                    confirmNumTotal - move_num_count
                ) {
                  newDetail.move_num_default = copyBatchDetail.position_num;
                  move_num_count += newDetail.move_num_default;
                }
              }

              //去除与newDetail中重复的字段;
              this.$delete(copyBatchDetail, "id");
              this.$delete(copyBatchDetail, "stock_num");
              //移出库位;
              var move_position_to = stockPositions.find(
                (position) => position.id == copyBatchDetail.stock_position.id
              );
              newDetail.move_position_to = move_position_to;
              newDetail.move_position_to.position_description = i18n.t(
                "MovePositionOrder.DetailFields.position",
                [move_position_to.position_code, move_position_to.position_name]
              );
              stockPositions.find((position) => {
                if (position.id == copyBatchDetail.stock_position.id) {
                  position.position_description = i18n.t(
                    "MovePositionOrder.DetailFields.position",
                    [position.position_code, position.position_name]
                  );
                  newDetail.move_position_to = position;
                }
              });
              //移入库位
              var positionsUsable = this.disabledPosition(newDetail);
              positionsUsable.some(
                function (position) {
                  if (!position.disabled) {
                    newDetail.move_position_in = position;
                    return true;
                  }
                }.bind(this)
              );
              //追加移库明细
              var firstItemKey = this.editAutoMoveDetail.findIndex(
                (move_detail) =>
                  move_detail.material_id == editDetail.material_id &&
                  !move_detail.new
              );

              var addedDetails = this.editAutoMoveDetail.filter(
                (move_detail) => move_detail.new
              );
              if (!addedDetails.length) {
                newDetail.new = 1;
              } else {
                newDetail.new = addedDetails.length + 1;
              }

              if (firstItemKey > -1) {
                newDetail.addMovePositionTo = null;
                Object.assign(
                  this.editAutoMoveDetail[firstItemKey],
                  Object.assign(newDetail, copyBatchDetail)
                );
              } else {
                if (Object.hasOwnProperty.call(newDetail, "addMovePositionTo"))
                  this.$delete(newDetail, "addMovePositionTo");
                this.editAutoMoveDetail.push(
                  Object.assign(newDetail, copyBatchDetail)
                );
              }
            }
          }
        }
      });
    },
    previewMethod(data) {
      if (this.isNew) return MovePositionOrders.addPreview(data);
      else if (this.mode == "edit") return MovePositionOrders.editPreview(data);
    },
    submitMethod(data) {
      if (this.isNew) return MovePositionOrders.addMovePositionOrder(data);
      else if (this.mode == "edit")
        return MovePositionOrders.editMovePositionOrder(data);
    },
    //提交预览移库单
    doPreview() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            var data = this.submitData();
            if (!this.errorMoveList.length && data.length) {
              this.moveOrderBeforPreview = JSON.stringify(this.moveOrder);
              var submit_preview_data = {};
              if (this.isNew) {
                submit_preview_data = {
                  type: this.moveOrder.type,
                  stock_id: this.stock_id,
                  operate_user_id: this.operateUser ? this.operateUser.id : 0,
                  move_details: data,
                };
                if (this.moveOrder.type == 1)
                  submit_preview_data.operation_type = this.move_type;
              } else {
                submit_preview_data = {
                  move_order_code: this.moveOrder.move_order_code,
                  move_details: data,
                };
              }
              this.previewMethod(submit_preview_data)
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.preview = true;
                      this.moveOrder = response.data.move_order;
                      this.moveOrderDetails =
                        response.data.move_order.move_details;
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    //提交移库单
    doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      var data = this.submitData();
      var submit_data = {};
      if (this.isNew) {
        submit_data = {
          type: this.moveOrder.type,
          stock_id: this.stock_id,
          operate_user_id: this.operateUser ? this.operateUser.id : 0,
          move_details: data,
        };
        if (this.moveOrder.type == 1)
          submit_data.operation_type = this.moveOrder.operation_type;
      } else {
        submit_data = {
          move_order_code: this.moveOrder.move_order_code,
          move_details: data,
        };
      }
      this.submitMethod(submit_data)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/move-position-order");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    //整理提交数据
    submitData() {
      var moveDetails = [];
      //提交前清除错误移库列表，重新校验
      this.errorMoveList = [];
      //整理提交详情，校验移库量
      if (this.isNew) {
        if (this.preview) {
          //预览
          this.moveOrderDetails.forEach((detail) => {
            moveDetails.push({
              material_code: detail.material_code,
              position_from_id: detail.position_from_id,
              position_to_id: detail.position_to_id,
              move_num: detail.move_num,
              stock_detail_id: detail.stock_detail_id,
            });
          });
        } else {
          //新增
          if (this.moveOrder.type == 2) {
            //自动移库

            var editDetail = [];
            this.editAutoMoveDetail.forEach((edit_move_detail) => {
              if (edit_move_detail.new) {
                editDetail.push(edit_move_detail);
              }
            });

            if (!editDetail.length) {
              this.$snackbar.error(
                i18n.t("MovePositionOrder.errorPreviewMoveDetailRequire")
              );
            } else {
              editDetail.forEach((detail) => {
                detail.move_num_count = 0;
                var batchMoveNumCount = 0; //某个库位批次的总移库量
                var positionNum = detail.position_num;

                if (editDetail.length == 1) {
                  if (detail.move_num_rate) {
                    batchMoveNumCount +=
                      detail.move_num_rate * detail.stock_rate;
                  }
                  if (detail.move_num_default) {
                    batchMoveNumCount += detail.move_num_default;
                  }
                  detail.move_num_count = batchMoveNumCount;

                  if (batchMoveNumCount > positionNum) {
                    this.errorMoveList.push(detail);
                  }
                } else {
                  //计算当前明细的总移库量
                  if (detail.move_num_rate) {
                    detail.move_num_count +=
                      detail.move_num_rate * detail.stock_rate;
                  }
                  if (detail.move_num_default) {
                    detail.move_num_count += detail.move_num_default;
                  }
                  //取相同批次详情
                  var sameBatchs = editDetail.filter(
                    (edit_detail) =>
                      edit_detail.material_id == detail.material_id &&
                      edit_detail.stock_detail_id == detail.stock_detail_id
                  );
                  var inErrorMoveList = this.errorMoveList.findIndex(
                    (errorDetail) =>
                      errorDetail.stock_detail_id == detail.stock_detail_id
                  );
                  //计算批次的总移库量，校验编辑移库量是否超过库位批次数量
                  sameBatchs.forEach((sameItem) => {
                    if (sameItem.move_num_rate) {
                      batchMoveNumCount +=
                        sameItem.move_num_rate * sameItem.stock_rate;
                    }
                    if (sameItem.move_num_default) {
                      batchMoveNumCount += sameItem.move_num_default;
                    }
                  });
                  //相同库位批次(移入库位不同)的总移库量
                  if (
                    batchMoveNumCount > positionNum &&
                    inErrorMoveList == -1
                  ) {
                    this.errorMoveList.push(detail);
                  }
                }

                if (!this.errorMoveList.length) {
                  moveDetails.push({
                    material_code:
                      this.autoMoveMaterialDetail[detail.material_id]
                        .material_code,
                    position_from_id: detail.move_position_to.id
                      ? detail.move_position_to.id
                      : 0,
                    position_to_id: detail.move_position_in.id
                      ? detail.move_position_in.id
                      : 0,
                    move_num: detail.move_num_count,
                    stock_detail_id: detail.stock_detail_id,
                  });
                }
              });
            }
          } else {
            if (this.move_type == 1) {
              this.materialBatchDetail.forEach((detail) => {
                detail.stock_details.forEach((stock_detail) => {
                  moveDetails.push({
                    material_code: stock_detail.material.material_code,
                    position_from_id: stock_detail.stock_position_id,
                    position_to_id: detail.moveTo.id,
                    move_num: stock_detail.position_num,
                    stock_detail_id: stock_detail.stock_detail_id,
                  });
                });
              });
            } else if (this.move_type == 2) {
              this.stockPositionBatchDetail.forEach((detail) => {
                var move_num_count =
                  detail.move_num_rate *
                    detail.stock_material.standard_detail.rate +
                  detail.move_num_default;
                if (move_num_count > detail.position_num) {
                  this.errorMoveList.push(detail);
                } else {
                  moveDetails.push({
                    material_code: detail.material.material_code,
                    position_from_id: detail.stock_position_id,
                    position_to_id: detail.moveTo.id ? detail.moveTo.id : "",
                    move_num: move_num_count,
                    stock_detail_id: detail.stock_detail_id,
                  });
                }
              });
            }
          }
        }
      } else if (this.mode == "edit") {
        this.moveOrderDetails.forEach((detail) => {
          if (
            detail.stock_material_position &&
            detail.stock_material_position.position_num < detail.move_num
          ) {
            this.errorMoveList.push(detail);
          } else {
            moveDetails.push({
              id: detail.id,
              move_num: detail.move_num,
            });
          }
        });
      }

      return moveDetails;
    },
    //移除部分库位批次或商品
    removeItem(data) {
      var removeItem = [];
      if (data.length == undefined || data.length == "undefined") {
        //手动移库
        if (this.moveOrder.type == 1) {
          //按商品移库移除部分库位批次，移除的批次做移除标识并removeData暂存，避免部分筛选过的商品重新请求列表导致移除掉的批次重新展现
          removeItem = this.stockPositionBatchDetail.find(
            (detail) => data.id == detail.id
          );
          var isPush = this.removeArr.findIndex(
            (arr) => arr.id == removeItem.id
          );
          if (isPush == -1) {
            this.removeArr.push(removeItem);
          }
          //当前选择下做移除
          this.stockPositionBatchDetail.splice(
            this.stockPositionBatchDetail.findIndex(
              (detail) => data.id == detail.id
            ),
            1
          );
        } else if (this.moveOrder.type == 2) {
          //自动移库
          var removeDetailKey = this.editAutoMoveDetail.findIndex(
            (detail) => detail.new == data.new
          );
          if (removeDetailKey > -1) {
            var unDelMaterialDetails = this.editAutoMoveDetail.filter(
              (move_detail) => move_detail.material_id == data.material_id
            );
            //判断这个商品的移库明细是否只剩下一条
            if (unDelMaterialDetails.length > 1) {
              this.editAutoMoveDetail.splice(removeDetailKey, 1);
            } else {
              //取原基本数据
              var updateData = JSON.parse(
                JSON.stringify(this.autoMoveMaterialDetail[data.material_id])
              );
              this.$delete(updateData, "stock_material_positions");
              this.$delete(updateData, "stock_positions");
              updateData.move_position_to = {};
              updateData.move_position_in = {};
              //移除带有移库详情的明细，添加不带移库详情的原数据
              this.editAutoMoveDetail.splice(removeDetailKey, 1);
              this.editAutoMoveDetail.push(updateData);
            }
          }
        }
      } else {
        //按库位移库移除部分库位批次
        data.forEach((item) => {
          this.materialBatchDetail.splice(
            this.materialBatchDetail.findIndex(
              (detail) => item.stock_position_id == detail.stock_position_id
            ),
            1
          );
        });
      }
    },
    //移库单下架
    shelveOffOrOnDetails() {
      var subDetails = [];
      this.moveOrderDetails.forEach((detail) => {
        subDetails.push({
          id: detail.id,
          stock_position_id:
            this.mode == "shelveOff"
              ? detail.position_from_id
              : this.mode == "shelveOn"
              ? detail.position_to_id
              : "",
          move_num: detail.move_num,
        });
      });
      return subDetails;
    },
    shelveOffMovePositionOrder() {
      this.$store.dispatch("fullscreenLoading");
      MovePositionOrders.shelveOff({
        move_id: this.moveOrder.id,
        move_details: this.shelveOffOrOnDetails(),
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/move-position-order");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    shelveOnMovePositionOrder() {
      this.$store.dispatch("fullscreenLoading");
      MovePositionOrders.shelveOn({
        move_id: this.moveOrder.id,
        move_details: this.shelveOffOrOnDetails(),
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/move-position-order");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    mode: {
      handler() {
        if (this.isNew) {
          this.panels = [0];
          this.tab = null;
          this.moveOrder = {
            type: 1,
            order_num_count: 0,
            confirm_num_count: 0,
            detail_length: 0,
          };
          this.moveOrderDetails = [];
          this.order_activities = [];
          this.filter = "";
          this.addMaterial = null;
        } else if (this.$route.params.id) {
          this.getMoveOrderDetailFromAPI();
        }
      },
    },
    accountUser: {
      handler() {
        this.operateUser = this.accountUser ? this.accountUser : null;
      },
    },
    stockSelected: {
      handler() {
        this.getMaterialPositionDetails(); //获取库位列表
        // if (this.stockSelected) {
        //   if (this.moveOrder.type == 2) {
        //     this.getAutoMoveMaterialList();
        //   } else {
        //     this.move_type = 2; //移库类型
        //   }
        // }
        this.moveMaterialSeleted = []; //移库商品select
        this.moveMaterial = []; //已选的移库商品
        this.moveStockPositionSelected = []; //移库库位select
        this.moveStockPosition = []; //已选的移库库位
        this.stockPositionBatchDetail = []; //以库位移库时的库位批次详情
        this.removeArr = []; //移库单编辑详情
        //自动移库
        this.editAutoMoveDetail = [];
        this.stockBatchSelectedDetail = [];
        this.stockPositionBatchs = [];
        this.stockBatchSelectedDetail = [];
      },
    },
    move_type: {
      handler() {
        this.moveMaterialSeleted = [];
        this.moveMaterial = [];
        this.moveStockPositionSelected = [];
        this.moveStockPosition = [];
        this.stockPositionBatchDetail = [];
        this.removeArr = [];
        this.autoMoveMaterialDetail = null;
      },
    },
    moveMaterialSeleted: {
      handler(now, old) {
        if (now.length > old.length) {
          this.moveMaterialSeleted.forEach((detail) => {
            var sameMaterial = this.moveMaterial.find(
              (item) => item.id == detail.id
            );
            if (sameMaterial == undefined || sameMaterial == "undefined") {
              this.moveMaterial.push(detail);
            }
          });
        }
      },
    },
    moveMaterial: {
      handler() {
        //获取商品ID
        var materialIds = [];
        this.moveMaterial.forEach((detail) => {
          materialIds.push(detail.material_id);
        });
        if (materialIds.length) {
          //获取库位批次详情
          this.getStockPositionBatchDetails({
            stock_id: this.stockSelected.id,
            material_ids: materialIds,
          });
        }
      },
    },
    stockPositionBatchDetail: {
      handler() {
        //获取库位批次详情中的商品
        this.moveMaterial.forEach((detail, key) => {
          var isFind = this.stockPositionBatchDetail.findIndex(
            (item) => item.material_id == detail.material_id
          );
          if (isFind < 0) {
            //某个商品的库存批次全部移除后，更新暂存所选商品array
            this.moveMaterial.splice(key, 1);
            this.moveMaterialSeleted.splice(
              this.moveMaterialSeleted.findIndex(
                (item) => item.material_id == detail.material_id
              ),
              1
            );
          }
        });
        //更新暂存移除库存批次array
        if (this.removeArr.length) {
          this.removeArr.forEach((arr, remove_key) => {
            var del_item = this.stockPositionBatchDetail.findIndex(
              (item) => item.material_id == arr.material_id
            );
            if (del_item < 0) {
              this.removeArr.splice(remove_key, 1);
            }
          });
        }
      },
    },
    errorMoveList: {
      handler() {
        if (this.errorMoveList.length) {
          this.errorMoveDialog = true;
        }
      },
    },
    moveStockPositionSelected: {
      handler(now, old) {
        if (now.length > old.length) {
          this.moveStockPositionSelected.forEach((detail) => {
            var samePosition = this.moveStockPosition.find(
              (item) => item.id == detail.id
            );
            if (samePosition == undefined || samePosition == "undefined") {
              this.moveStockPosition.push(detail);
            }
          });
        }
      },
    },
    moveStockPosition: {
      handler() {
        //获取库位ID
        var positionIds = [];
        this.moveStockPosition.forEach((detail) => {
          positionIds.push(detail.id);
        });

        if (positionIds.length) {
          //获取库位批次详情
          this.getStockPositionBatchDetails({
            stock_id: this.stockSelected.id,
            stock_position_ids: positionIds,
          });
        }
      },
    },
    materialBatchDetail: {
      handler() {
        this.moveStockPosition.forEach((detail, key) => {
          var isFind = this.materialBatchDetail.findIndex(
            (item) => item.stock_position_id == detail.id
          );

          if (isFind < 0) {
            this.moveStockPosition.splice(key, 1);
            this.moveStockPositionSelected.splice(
              this.moveStockPositionSelected.findIndex(
                (item) => item.id == detail.id
              ),
              1
            );
          }
        });
      },
    },
    moveOrder: {
      deep: true,
      handler() {
        if (this.moveOrder.type == 2 && this.stock_id) {
          this.move_type = 0;
          //自动移库
          this.editAutoMoveDetail = [];
          this.stockBatchSelectedDetail = [];
          this.stockPositionBatchs = [];
          this.stockBatchSelectedDetail = [];

          this.getAutoMoveMaterialList();
        } else if (this.moveOrder.type == 1 && this.stock_id) {
          this.move_type = 2;
        } else {
          this.autoMoveMaterialDetail = null;
          this.editAutoMoveDetail = [];
        }
      },
    },
    editAutoMoveDetail: {
      deep: true,
      handler() {
        //编辑的商品的详情
        var editMaterial = this.editAutoMoveDetail.find(
          (material_detail) =>
            material_detail.addMovePositionTo &&
            Object.keys(material_detail.addMovePositionTo).length
        );
        if (editMaterial) {
          for (var key in this.autoMoveMaterialDetail) {
            var detail = this.autoMoveMaterialDetail[key];
            if (detail.material_id == editMaterial.material_id) {
              //获取该商品的库位批次信息
              this.stockBatchDialog = true;
              var positionId = editMaterial.addMovePositionTo.id;
              this.stockPositionBatchs = JSON.parse(
                JSON.stringify(
                  this.autoMoveMaterialDetail[key].stock_material_positions[
                    positionId
                  ]
                )
              );

              this.stockPositionBatchs.forEach((batch) => {
                batch.material_description =
                  this.autoMoveMaterialDetail[key].material_description;
                batch.position_description =
                  editMaterial.addMovePositionTo.position_description;
              });
            }
          }
        }
      },
    },
    stockBatchSelectedDetail: {
      handler() {
        var materialId = 0;
        var editDetail = {};
        if (this.stockBatchSelectedDetail) {
          this.stockBatchSelectedDetail.forEach((selected_detail) => {
            materialId = selected_detail.material_id;
            var addDetail = JSON.parse(JSON.stringify(selected_detail)); //深拷贝
            //防止添加相同批次信息时，报id重复的警告
            addDetail.stock_material_position_id = addDetail.id;
            this.$delete(addDetail, "id");
            //从原数据中获取详情字段
            editDetail = this.editAutoMoveDetail.find(
              (edit_detail) =>
                edit_detail.material_id == addDetail.material_id &&
                Object.keys(edit_detail.addMovePositionTo).length
            );
            if (editDetail) {
              addDetail.move_position_to = editDetail.addMovePositionTo;
              addDetail.default_unit = editDetail.default_unit;
              addDetail.stock_rate = editDetail.stock_rate;
              addDetail.stock_unit = editDetail.stock_unit;
              //单位转换
              if (addDetail.stock_rate > 1) {
                var batchNumRate = parseInt(
                  addDetail.position_num / addDetail.stock_rate
                );
                if (addDetail.position_num % addDetail.stock_rate) {
                  var batchNumDefault =
                    addDetail.position_num % addDetail.stock_rate;
                  addDetail.stock_position_batch_num_rate = i18n.t(
                    "MovePositionOrder.DetailFields.quantityWithMultipleUnits",
                    [
                      batchNumRate,
                      addDetail.stock_unit,
                      batchNumDefault,
                      addDetail.default_unit,
                    ]
                  );
                } else {
                  addDetail.stock_position_batch_num_rate = i18n.t(
                    "MovePositionOrder.DetailFields.quantityWithUnit",
                    [batchNumRate, addDetail.stock_unit]
                  );
                }
              } else {
                addDetail.stock_position_batch_num_default = i18n.t(
                  "MovePositionOrder.DetailFields.quantityWithUnit",
                  [addDetail.position_num, addDetail.default_unit]
                );
              }
            }

            //所选的批次详情加入到详情列表中
            var updateMoveDetailKey = this.editAutoMoveDetail.findIndex(
              (move_detail) =>
                move_detail.material_id == addDetail.material_id &&
                move_detail.addMovePositionTo &&
                !move_detail.new
            );
            var newDetails = this.editAutoMoveDetail.filter(
              (move_detail) => move_detail.new
            );
            if (!newDetails.length) {
              addDetail.new = 1;
            } else {
              addDetail.new = newDetails.length + 1;
            }

            if (updateMoveDetailKey > -1) {
              addDetail.stock_num =
                this.editAutoMoveDetail[updateMoveDetailKey].stock_num;

              Object.assign(
                this.editAutoMoveDetail[updateMoveDetailKey],
                addDetail
              );
            } else {
              this.editAutoMoveDetail.push(addDetail);
            }
          });
          // 清空编辑项的库位select
          editDetail = this.editAutoMoveDetail.find(
            (edit_detail) =>
              edit_detail.material_id == materialId &&
              Object.keys(edit_detail.addMovePositionTo).length
          );
          if (editDetail) {
            editDetail.addMovePositionTo = null;
          }
        }
      },
    },
    stockBatchDialog: {
      handler() {
        if (!this.stockBatchDialog) {
          //未选择批次关闭弹窗后，清除库位下拉框
          var moveDetail = this.editAutoMoveDetail.find(
            (move_detail) =>
              move_detail.addMovePositionTo &&
              Object.keys(move_detail.addMovePositionTo).length
          );
          if (moveDetail) {
            moveDetail.addMovePositionTo = null;
          }
        }
      },
    },
  },
};
</script>